import {Component, computed, inject, signal} from '@angular/core';
import {Divider} from 'primeng/divider';
import {Password} from 'primeng/password';
import {Button} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {FloatLabel} from 'primeng/floatlabel';
import {Message} from 'primeng/message';
import {UsersFacade} from '../../users.facade';

@Component({
	selector: 'app-user-password-panel',
	standalone: true,
	imports: [
		Divider,
		Password,
		Button,
		FormsModule,
		FloatLabel,
		Message
	],
	template: `
		<p-divider align="left"><strong>Cambia password</strong></p-divider>
		<div class="flex flex-column gap-3">
			<p-floatlabel class="w-full" variant="on">
				<p-password inputId="newPassword"
							[(ngModel)]="newPassword"
							[toggleMask]="true"
							[feedback]="true"
							weakLabel="Password non sicura"
							mediumLabel="Password poco sicura"
							strongLabel="Password sicura"
							promptLabel="Inserisci una password"
							fluid />
				<label for="newPassword">Nuova password</label>
			</p-floatlabel>

			<p-floatlabel class="w-full" variant="on">
				<p-password inputId="repeatPassword"
							[(ngModel)]="repeatPassword"
							[toggleMask]="true"
							[feedback]="false"
							fluid />
				<label for="repeatPassword">Ripeti password</label>
			</p-floatlabel>

			@if (passwordMismatch()) {
				<p-message severity="error">Le password non coincidono</p-message>
			}

			<div class="flex justify-content-end">
				<p-button label="Aggiorna password"
						  size="small"
						  [disabled]="!canSubmit()"
						  [loading]="loading()"
						  (onClick)="changePassword()" />
			</div>
		</div>
	`
})
export class UserPasswordPanelComponent {
	private facade = inject(UsersFacade)

	readonly newPassword = signal('');
	readonly repeatPassword = signal('');
	readonly loading = signal(false);

	readonly passwordMismatch = computed(() =>
		this.repeatPassword().length > 0 &&
		this.newPassword() !== this.repeatPassword()
	);

	readonly canSubmit = computed(() =>
		this.newPassword().length >= 8 &&
		this.newPassword() === this.repeatPassword()
	);

	changePassword() {
		if (!this.canSubmit()) return;

		this.facade.updateUserPassword(this.newPassword())
	}
}
